import {IHttpMonitorItem} from 'features/http/model/HttpMonitor/IHttpMonitor';

export type GeoStatusState = 'paused' | 'waiting' | 'all_ok' | 'warning' | 'incident';
export type GeoStatusTone = 'success' | 'warning' | 'problem' | 'neutral';

export const GEO_STATE_TONE: Record<GeoStatusState, GeoStatusTone> = {
    all_ok: 'success',
    warning: 'warning',
    incident: 'problem',
    paused: 'neutral',
    waiting: 'neutral',
};

export const getGeoStatusState = (item: IHttpMonitorItem): GeoStatusState => {
    if (item.status === 'paused') return 'paused';
    if (item.ok === null) return 'waiting';

    const fail = item.fail_locations_count ?? 0;
    const threshold = item.threshold ?? 0;

    if (fail === 0) return 'all_ok';
    if (threshold > 0 && fail >= threshold) return 'incident';
    return 'warning';
};
